import { Component, OnInit, Injectable, ViewChild, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { defer, fromEvent, merge, Observable, of } from 'rxjs';
import { switchMapTo } from 'rxjs/operators';
import { PpBreadcrumbsService, Breadcrumb } from 'pp-breadcrumbs';
import { User } from 'app/model/user';
import { AuthService } from 'app/core/auth/services/auth.service';
import { UserContextService } from 'app/core/auth/services/user-context.service';
import { UsuariosService } from 'app/api/usuarios.service';
import { Servico } from 'app/model/servico';
import { SubSink } from 'subsink';
import { Evento } from 'app/model/evento'; // É a model para Notificações
import { NotificacoesApiService } from 'app/api/notificacoesApi.service';
import { ServicoApiService } from 'app/api/servicoApi.service';

import * as moment from 'moment';
import { NavigationEnd, NavigationError, NavigationStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router, Event } from '@angular/router';

@Injectable()


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  
  servicos$: Observable<Servico[]>;
  isLoading = false;

  constructor( 
              public userContextService: UserContextService,
              public authService: AuthService,
              private usuariosService: UsuariosService,
              private notificacoesService: NotificacoesApiService,
              private servicosService: ServicoApiService,
              private router: Router,
              private breadcrumbsService: PpBreadcrumbsService) {}

  title = 'LUCOR';
  subtitle = 'Tecnologia em Gestão de Pessoas.';
  year: number;
  verificaUsuario$: Observable<User>;
  profile = false;
  isShow: boolean;
  topPosToStartShowing = 200;
  userFirstName: string;
  authLogin = false;
  acessoCliente: boolean;

  
  intervalo = null;
  
  public isOffline$;
  opened = false;
  
  acessoAgente = false;
  bloqueioAcessoAgente = false;
  saldoAcessoAgente = 0;

  // Inclusão de notificações
  notificacoes: Evento[] = [];
  private subs = new SubSink();
  
  @ViewChild('sideBarView') sideBarView: ElementRef;
  @ViewChild('menuProfile') menuProfile: ElementRef;

  @HostListener('document:click', ['$event'])
  onMouseDown(event): void {
    this.func(event.target);
  }

  func(element) {
    if (element && !element.classList.contains('nav-side') && !element.classList.contains('checkToggle')) {
      this.checkSidebar();
    } else {
      this.toggleSidebar();
    }
  }

  @HostListener('window:scroll')
  checkScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isShow = scrollPosition >= this.topPosToStartShowing ? true : false;
  }

  ngOnInit() {

    this.router.events.subscribe((event: Event) => {
      
      // Dispara ASSIM QUE O USUÁRIO CLICA no botão (Início da navegação ou download do JS)
      if (event instanceof NavigationStart || event instanceof RouteConfigLoadStart) {
        this.isLoading = true;
      }

      // Desativa quando a página terminou de renderizar por completo
      if (event instanceof NavigationEnd || 
          event instanceof NavigationError || 
          event instanceof RouteConfigLoadEnd) {
        this.isLoading = false;
      }
      
    });


    this.onlineOffline();

    this.authLogin = this.authService.isLoggedIn();

    if (this.authLogin) {

      if (this.userContextService.user) {
        this.userContextService.user.pessoaJuridicaId === null  && this.userContextService.user.roles.includes("Administrador") ? this.acessoCliente = false : this.acessoCliente = true;
        if(this.acessoCliente) this.getServicosByCliente(this.userContextService.user.pessoaJuridicaId);
        this.setUsuario();
      } else {
        this.subs.sink = this.usuariosService.v1UsuariosLogadoGet()
          .subscribe({
            next: (usuarioLogado) => {
              if (usuarioLogado) {
                this.userContextService.user = usuarioLogado;
                usuarioLogado.pessoaJuridicaId === null && usuarioLogado.roles.includes("Administrador") ? this.acessoCliente = false : this.acessoCliente = true;
                if(this.acessoCliente) this.getServicosByCliente(usuarioLogado.pessoaJuridicaId);
                this.setUsuario();
              }
            },
            error: (err) => {
              console.error('Erro ao buscar usuário logado', err);
            }
        });
      }

    } else {
      this.router.navigate(['/login']);
    }
    this.year = new Date().getFullYear();
    this.opened = false;
    this.breadcrumbs();

  }

  isLoginRoute(): boolean {
    return this.router.url.includes('/login');
  }

  onLogout() {
    this.authService.logout();
    this.userContextService.user = undefined;
    this.authLogin = false;
    this.acessoAgente = false;
    this.bloqueioAcessoAgente = false;
    this.saldoAcessoAgente = 0;
    if (this.intervalo) clearInterval(this.intervalo);
    this.router.navigate(['/login']);
  }

  setUsuario() {

    this.authService.checarCronometroToken();

    this.userFirstName = this.userContextService.user.userName.split('.')[0];

    // Acesso administrador
    if (!this.acessoCliente && this.authLogin) {
      
      setTimeout(() => {
        this.loadNotifications();
      }, 500);

      const QUINZE_MINUTOS = 15 * 60 * 1000;
      
      this.intervalo = setInterval(() => {
        this.loadNotifications();
      }, QUINZE_MINUTOS); 

      this.acessoAgente = true;
      this.bloqueioAcessoAgente = false;
      
    } 

  }

  openProfile() {
    this.profile = !this.profile;
    if(this.menuProfile) {
      if (this.profile === true) {
        this.menuProfile.nativeElement.classList.add('open');
      } else {
        this.menuProfile.nativeElement.classList.remove('open');
      }
    }
  }


  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  breadcrumbs() {
    this.breadcrumbsService.postProcess = (breadcrumbs: Breadcrumb[]) => {
      if (breadcrumbs.length >= 0) {
        breadcrumbs.unshift({ text: `Dashboard`, path: 'home' });
      }
      return breadcrumbs;
    };
  }

  private openSideBar() {
    if(this.sideBarView) {
      if (!this.opened) {
        this.sideBarView.nativeElement.classList.remove('open');
      } else {
       this.sideBarView.nativeElement.classList.add('open');
      }
    }
  }

  private checkSidebar() {
    if (this.opened) {
      this.toggleSidebar();
    }
  }

  toggleSidebar() {
    this.opened = !this.opened;
    this.openSideBar();
  }

  private onlineOffline() {
    const initialEvent$ = of(null);
    const onlineEvent$ = fromEvent(window, 'online');
    const offlineEvent$ = fromEvent(window, 'offline');
    const isOfflineDefer$ = defer(() => of(!window.navigator.onLine));

    this.isOffline$ = merge(initialEvent$, onlineEvent$, offlineEvent$).pipe(
      switchMapTo(isOfflineDefer$)
    );

  }

  private loadNotifications() {
    
    if(!this.acessoCliente) {

      this.notificacoes = [];

      // const dataInicio = moment('2025-08-15', 'YYYY-MM-DD').startOf('day');
      // const dataFim = moment('2025-08-21', 'YYYY-MM-DD').endOf('day');

      const dataInicio = moment().startOf('day');
      const dataFim = moment().endOf('day');

      const newDataInicialFormatada = dataInicio.toDate();
      const newDataFinalFormatada = dataFim.toDate();

      this.subs.sink = this.notificacoesService.v1NotificacoesGet(
      newDataInicialFormatada,
      newDataFinalFormatada,
      null, // this.webhookForm.value.pessoaJuridicaId,
      false, // inputApenasPendentes,
      null, // this.webhookForm.value.entidadeId,
      null, // this.webhookForm.value.urlContains,
      null, //this.webhookForm.value.ids,
      ).subscribe( webhookNotifications => {
        if(webhookNotifications) {
          webhookNotifications.forEach(notification => {
            if(notification.tipoAcao === "Inclusao" && notification.tipoNotificacao === "MensagemEmail") {
              this.notificacoes.push(notification);
            }
          })
        }
      });

    }

  }

  private getServicosByCliente(id: number): void {
    // this.servicos$ = this.servicosService.v1ServicoClienteClienteIdGet(id);
    // this.servicos$.subscribe(servicos => {
    this.subs.sink = this.servicosService.v1ServicoClienteClienteIdGet(id)
        .subscribe(servicos => {
          servicos.forEach(servico => {
            if(servico.tipoServico.codigo === 'IA' && servico.tipoServico.nome === 'Agente IA') {
              
              // Libera o acesso ao Chat do agente
              this.acessoAgente = true;

              // Verifica e mostra o número de saldo restante
              this.saldoAcessoAgente = servico.unidadesContratadas - servico.unidadesUtilizadas;

              // Verifica o saldo de unidade restante
              if(this.saldoAcessoAgente === 0) this.bloqueioAcessoAgente = true; 

            }
          })
      });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
    if (this.intervalo) clearInterval(this.intervalo);
  }

}
